/**
 * Created by hashinig on 1/4/19.
 */
(function () {
  'use strict';

  angular
    .module('flightWatch')
    .controller('FlightCheckLogDetailsCtrl', FlightCheckLogDetailsCtrl);

  function FlightCheckLogDetailsCtrl($uibModalInstance, modalParams) {
    var vm = this;

    vm.model = {
      flightCheckLogs:modalParams.checkLogDetails
    };


    vm.onCloseClick = function () {
      $uibModalInstance.close();
    };

  }
}());
